import { IApplicationState } from '../../types/redux';

export const selectOfferForAnalytic = (state: IApplicationState) => state.analytic.offerForAnalytics;
